export default __webpack_public_path__ + "static/media/W51Exterior2.97332280.jpg";